import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useFollows } from "./useFollows"

export function useFollowById(id?: Follow["id"]): [Follow | undefined, boolean] {
  const {
    data: follows,
    isLoading,
  } = useFollows()

  const follow = useMemo(
    () => follows?.find(
      (cachedFollow) => cachedFollow.id === id && cachedFollow.deleted_at === null,
    ),
    [
      follows,
      id,
    ],
  )

  const hasLoaded = !(isLoading || follows === undefined)

  return [
    follow,
    hasLoaded,
  ]
}

